import { notificationReadsApi } from '@/modules/notifications/reads.api'

import type { NotificationQueryDto, PaginationParams } from '@scrambl/shared'

import { queryKeys } from '../query-keys'
import { useNotificationReadSession } from './useNotificationReadSession'
import { useNotificationScopedQuery } from './useNotificationScopedQuery'

export function useNotificationsQuery(
  query?: NotificationQueryDto & PaginationParams,
  options?: { enabled?: boolean },
) {
  const session = useNotificationReadSession()
  return useNotificationScopedQuery(
    queryKeys.notifications.list(query),
    session,
    context => notificationReadsApi.list(query ?? {}, context),
    { ...options, staleTime: 10000 },
  )
}
export function useNotificationQuery(
  notificationId: string | undefined,
  options?: { enabled?: boolean },
) {
  const session = useNotificationReadSession()
  return useNotificationScopedQuery(
    queryKeys.notifications.detail(notificationId ?? ''),
    session,
    context => notificationReadsApi.detail(notificationId!, context),
    { enabled: options?.enabled !== false && !!notificationId },
  )
}
export function useUnreadNotificationCountQuery(options?: {
  enabled?: boolean
}) {
  const session = useNotificationReadSession()
  return useNotificationScopedQuery(
    queryKeys.notifications.unreadCount(),
    session,
    notificationReadsApi.unreadCount,
    { ...options, staleTime: 30000 },
  )
}
export function useNotificationSummaryQuery(options?: { enabled?: boolean }) {
  const session = useNotificationReadSession()
  return useNotificationScopedQuery(
    queryKeys.notifications.summary(),
    session,
    notificationReadsApi.summary,
    { ...options, staleTime: 30000 },
  )
}
export function useNotificationPreferencesQuery(options?: {
  enabled?: boolean
}) {
  const session = useNotificationReadSession()
  return useNotificationScopedQuery(
    queryKeys.notifications.preferences(),
    session,
    notificationReadsApi.preferences,
    options,
  )
}
